// extracted by css-extract-rspack-plugin
export default {"borderRight":"rr_Jv"};